import React, { useEffect } from 'react';
import { PSE_CX } from '../../utils/searchConfig';

/**
 * Google Programmable Search Engine results, rendered in-page.
 *
 * Loads Google's cse.js once (explicit parsetags so it doesn't scan the
 * whole DOM), then renders a results-only element into our div. The widget
 * reads the query from the ?q= URL parameter and executes automatically.
 *
 * Free tier: unlimited queries, "powered by Google" branding, ads may be
 * interleaved with results. Google receives the visitor's IP and query —
 * disclosed in the cookie banner.
 */

const DIV_ID = 'aw-gcse-results';

function renderElement(query) {
  const g = window.google;
  if (!g || !g.search || !g.search.cse || !g.search.cse.element) return;
  // Re-render fresh each time (SPA navigations reuse the mounted div)
  const el = document.getElementById(DIV_ID);
  if (!el) return;
  el.innerHTML = '';
  g.search.cse.element.render({
    div: DIV_ID,
    tag: 'searchResults-only',
    gname: 'aw-results',
  });
  const rendered = g.search.cse.element.getElement('aw-results');
  if (rendered && query) rendered.execute(query);
}

const GoogleSearchResults = ({ query }) => {
  useEffect(() => {
    if (!PSE_CX) return;
    if (window.__awGcseReady) {
      renderElement(query);
      return;
    }
    window.__gcse = {
      parsetags: 'explicit',
      callback: () => {
        window.__awGcseReady = true;
        renderElement(query);
      },
    };
    if (!document.querySelector('script[data-aw-gcse]')) {
      const s = document.createElement('script');
      s.src = 'https://cse.google.com/cse.js?cx=' + encodeURIComponent(PSE_CX);
      s.async = true;
      s.setAttribute('data-aw-gcse', '1');
      document.head.appendChild(s);
    }
  }, [query]);

  if (!PSE_CX) return null;

  return <div id={DIV_ID} className="aw-gcse-wrap" />;
};

export default GoogleSearchResults;
